
export class LoadingDropdown {
    _loading = false;
    loadingStyleClass = '';

    private t = 0;

    get loading() {
        return this._loading;
    }

    set loading(loading) {
        if (loading) {
            let frame = 0;

            if (this.t)
                window.clearInterval(this.t);

            this.t = window.setInterval(() => {
                this.loadingStyleClass = `load-frame-${frame++ % 4}`;
            }, 160);
        } else {
            this.loadingStyleClass = '';
            window.clearInterval(this.t);
        }
        this._loading = loading;
    }
}